import { render, staticRenderFns } from "./EditorClinicHealthImageDialog.vue?vue&type=template&id=dea88dea&scoped=true"
import script from "./EditorClinicHealthImageDialog.vue?vue&type=script&lang=js"
export * from "./EditorClinicHealthImageDialog.vue?vue&type=script&lang=js"
import style0 from "./EditorClinicHealthImageDialog.vue?vue&type=style&index=0&id=dea88dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea88dea",
  null
  
)

export default component.exports